import { formValidate } from "./validate/index"
formValidate()

import * as select from "./select/index"
select.init()

import * as date from "./date/index"
date.init()

import * as input from "./input/index"
input.controlButtonClearInput()
